export enum BISessionEndType {

    Regular = "Regular",
    Timeout = "Timeout",
    Forced = "Forced"
}
